import React from 'react';

const ShareProgramContext = React.createContext({
  referralInfo: {},
  affiliateInfo: {},
});

export default ShareProgramContext;
